import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import userIcon from 'assets/img/user.svg';
import style from './style.module.css';
import { findLetter } from '../utils/general';
import { CloseButton } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { CROSS_ICON } from '../../kanban/assets/image';
import ConfirmModal from 'components/ConfirmModal';
import { useAuth } from 'contexts/AuthContext';

export default function AvatarGroup({
  members,
  size,
  limit = 4,
  handleClick = () => {},
  membersList = [],
  isCalender = false,
  handleRemove = () => {},
  showRemove = false,
  showProfileModal = () => {},
  isfromMilestoneModal = false,
  viewMode = false
}) {
  const { user } = useAuth();
  const [tooltip, setTooltip] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [assigneeToRemove, setAssigneeToRemove] = useState(null);
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [show, setShow] = useState(false); // ✅ manage dropdown state
  const [popover, setPopover] = useState({
    visible: false,
    member: null,
    top: 0,
    left: 0
  });
  const [isPopoverHovered, setIsPopoverHovered] = useState(false);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // const [isDeleting, setDeleting] = useState(false);
  const avatarRefs = useRef({});

  // 🔑 Normalize the data so render logic is simpler
  const resolvedMembers = (isCalender ? membersList : members)?.slice(0, limit).map((item) => {
    // if it's a string id, find it in the other array
    if (typeof item === 'string') {
      return members?.find((m) => m._id === item) || {};
    }
    return item;
  });

  const totalCount = isCalender ? membersList?.length : members?.length;

  const showTooltip = (memberId, name) => {
    const avatar = avatarRefs.current[memberId];
    if (avatar) {
      const rect = avatar.getBoundingClientRect();
      setTooltip({
        name,
        top: rect.top + window.scrollY - 35,
        left: rect.left + window.scrollX + rect.width / 2
      });
    }
  };

  const hideTooltip = () => {
    setTooltip(null);
    setHoveredId(null);
  };

  useEffect(
    () => () => {
      setTooltip(null);
      setHoveredId(null);
    },
    []
  );

  const removeAssigneeText = (
    <>
      <h2 className="mb-3">Are you sure?</h2>
      <h3>You want to remove this assignee?</h3>
    </>
  );
  return (
    <>
      <div
        className={style.avatar_group}
        style={{ gap: isCalender ? '0px' : '0px' }}
        onClick={(e) => {
          if (showRemove) e.stopPropagation();
        }}>
        {resolvedMembers?.map((value) => {
          const name = value?.fullName || value?.email || '';

          const handleAvatarEnter = () => {
            const avatar = avatarRefs.current[value?._id];
            if (!avatar) return;

            const rect = avatar.getBoundingClientRect();
            if (!viewMode) {
              if (isfromMilestoneModal) {
                setPopover({
                  visible: true,
                  member: value,
                  top: rect.bottom + window.scrollY, // a bit below avatar
                  left: rect.left + window.scrollX + rect.width / 2
                });
              } else {
                showTooltip(value._id, value.fullName);
              }
            }
            setHoveredId(value?._id);
          };

          const handleAvatarLeave = () => {
            // small timeout so you can move mouse from avatar to popover
            if (isfromMilestoneModal) {
              // setTimeout(() => {
              if (!isPopoverHovered) {
                setPopover((prev) => ({ ...prev, visible: false, member: null }));
                setHoveredId(null);
              }
              // }, 80);
            } else {
              hideTooltip();
            }
          };

          return (
            <div
              key={value?._id}
              ref={(el) => (avatarRefs.current[value?._id] = el)}
              className={style.avatar}
              onMouseEnter={handleAvatarEnter}
              onMouseLeave={handleAvatarLeave}
              style={
                size
                  ? {
                      width: `${size}px`,
                      height: `${size}px`,
                      minWidth: `${size}px`,
                      lineHeight: `${size}px`,
                      position: 'relative'
                    }
                  : {}
              }>
              {/* {hoveredId === value?._id && showRemove && (
                <img
                  className="close_icon"
                  src={CROSS_ICON}
                  alt="close-icon"
                  onClick={(e) => {
                    if (showRemove) e.stopPropagation();
                    setAssigneeToRemove(value?._id);
                    setShowConfirm(true);
                  }}
                />
              )} */}

              {value?.profilePic ? (
                <img
                  src={value?.profilePic || userIcon}
                  alt="user"
                  style={size ? { width: `${size}px`, height: `${size}px` } : {}}
                />
              ) : (
                findLetter(name)
              )}
            </div>
          );
        })}

        {totalCount > limit && (
          <div
            className={style.avatar_empty}
            style={size ? { width: `${size}px`, height: `${size}px`, minWidth: `${size}px` } : {}}>
            +{totalCount - limit}
          </div>
        )}
        {/* {totalCount > limit && (
          <Dropdown
            ref={dropdownRef}
            show={showDropdown}
            onToggle={(isOpen) => setShowDropdown(isOpen)}
          >
            <div
              onClick={(e) => {
                e.stopPropagation();
                setShowDropdown((prev) => !prev); 
              }}
              className={style.avatar_empty}
              style={size ? { width: `${size}px`, height: `${size}px`, minWidth: `${size}px` } : {}}>
              +{totalCount - limit}
            </div>

            <Dropdown.Menu>
              <Dropdown.ItemText className="fw-bold">
                Members 
                <img
                  src={CROSS_ICON}
                  alt="remove"
                  className="ms-2"
                  style={{ cursor: 'pointer', width: '14px', height: '14px' }}
                />
              </Dropdown.ItemText>
              {(isCalender ? membersList : members)?.slice(limit).map((member) => {
                const name = member?.fullName || member?.email || '';
                return (
                  <Dropdown.ItemText key={member?._id}>
                    <div className="d-flex align-items-center">
                      {member?.profilePic ? (
                        <img
                          src={member?.profilePic || userIcon}
                          alt="user"
                          style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            marginRight: '8px'
                          }}
                        />
                      ) : (
                        <span
                          style={{
                            display: 'inline-block',
                            width: '24px',
                            height: '24px',
                            lineHeight: '24px',
                            borderRadius: '50%',
                            background: '#ddd',
                            textAlign: 'center',
                            marginRight: '8px'
                          }}>
                          {name?.charAt(0).toUpperCase()}
                        </span>
                      )}
                      {name}
                    </div>
                  </Dropdown.ItemText>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        )} */}
      </div>

      {popover.visible &&
        popover.member &&
        ReactDOM.createPortal(
          <div
            className={style.popoverWrapper}
            style={{ top: popover.top, left: popover.left }}
            onMouseEnter={() => setIsPopoverHovered(true)}
            onMouseLeave={() => {
              setIsPopoverHovered(false);
              setPopover((prev) => ({ ...prev, visible: false, member: null }));
              setHoveredId(null);
            }}>
            <div className={style.popoverCard}>
              <button
                className={style.popoverClose}
                onClick={() => setPopover((prev) => ({ ...prev, visible: false, member: null }))}>
                ×
              </button>

              <div className={style.popoverHeader}>
                {/* avatar inside popover (optional) */}
                {popover.member?.profilePic ? (
                  <img src={popover.member.profilePic || userIcon} alt="user" className={style.popoverAvatar} />
                ) : (
                  <div className={style.popoverAvatar}>
                    {findLetter(popover.member.fullName || popover.member.email || '')}
                  </div>
                )}
                <span className={style.popoverName}>{popover.member.fullName || popover.member.email}</span>
              </div>

              {popover.member._id == user._id && (
                <button
                  className={style.popoverButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPopover((prev) => ({ ...prev, visible: false, member: null }));
                    showProfileModal(); // your edit handler
                  }}>
                  Edit profile info
                </button>
              )}

              {showRemove && (
                <button
                  className={style.popoverButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPopover((prev) => ({ ...prev, visible: false, member: null }));
                    setAssigneeToRemove(popover.member?._id);
                    setShowConfirm(true); // reuse your ConfirmModal
                  }}>
                  Remove from card
                </button>
              )}
            </div>
          </div>,
          document.body
        )}

      {/* Tooltip */}
      {tooltip &&
        ReactDOM.createPortal(
          <div className={style.tooltipPortal} style={{ top: tooltip.top, left: tooltip.left }}>
            {tooltip.name}
          </div>,
          document.body
        )}
      <ConfirmModal
        show={showConfirm}
        onHide={(e) => {
          e?.stopPropagation?.(); // ✅ stop bubbling
          setShowConfirm(false);
        }}
        confirmationText={removeAssigneeText}
        handleAction={(e) => {
          e?.stopPropagation?.(); // ✅ stop bubbling
          setShowConfirm(false);
          handleRemove(assigneeToRemove);
        }}
        closeText="Yes"
        bgClassname={'whitebgmodal'}
        // loading={isSaving}
      />
    </>
  );
}
